import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useActiveSlide } from "../../context/active-slide-context";
import VisuallyHidden from "../VisuallyHidden";
import phoneMockup from "../../images/social-mockup.png";

import "swiper/css";
import * as styles from "./phone-carousel.module.css";
import Icon from "../Icon";

const PhoneCarousel = ({ children, autoplay = false }) => {
  const { setActiveIndex, isPaused } = useActiveSlide();
  const swiperRef = React.useRef(null);

  // Pause/resume autoplay based on context
  React.useEffect(() => {
    if (!swiperRef.current || !autoplay) return;
    if (isPaused) {
      swiperRef.current.autoplay?.stop();
    } else {
      swiperRef.current.autoplay?.start();
    }
  }, [isPaused, autoplay]);

  const swiperContainerStyles = {
    height: "96%",
    width: "92%",
    position: "absolute",
    bottom: "2%",
    top: "2%",
    left: "4%",
    right: "4%",
    borderRadius: "8%",
    backgroundColor: "black",
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <Swiper
          modules={autoplay ? [Autoplay] : []}
          onBeforeInit={swiper => {
            swiperRef.current = swiper;
          }}
          onSlideChange={swiper => {
            setActiveIndex(swiper.activeIndex);
          }}
          speed={350}
          slidesPerView={1}
          slidesPerGroup={1}
          direction="vertical"
          rewind={true}
          autoplay={
            autoplay ? { delay: 4000, disableOnInteraction: true } : false
          }
          style={swiperContainerStyles}
        >
          {React.Children.map(children, child => (
            <SwiperSlide>{child}</SwiperSlide>
          ))}
        </Swiper>
        <img
          loading="eager"
          src={phoneMockup}
          alt=""
          width={500}
          height={1019}
          className={styles.phone}
        />
      </div>
      {children.length > 1 && (
        <>
          <button
            onClick={() => swiperRef.current?.slidePrev()}
            className={styles.navButton}
            data-direction="previous"
          >
            <Icon name="chevron" size="2.8rem" />
            <VisuallyHidden>Navigate to previous slide</VisuallyHidden>
          </button>
          <button
            onClick={() => swiperRef.current?.slideNext()}
            className={styles.navButton}
            data-direction="next"
          >
            <Icon name="chevron" size="2.8rem" />
            <VisuallyHidden>Navigate to next slide</VisuallyHidden>
          </button>
        </>
      )}
    </div>
  );
};

export default PhoneCarousel;
